import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiListBoxOutline } from "@mdi/js";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { Menu } from "./Menu";

export const MaterialRequestFormsMenu: React.FC<Menu> = memo(
  ({ handleClick, leftMenuOpen, user }) => {
    const { t } = useTranslation();

    if (!user.roles_names.includes("Material Request Form - View")) {
      return null;
    }

    return (
      <HybridRouteListItemButtonLink
        caption="material request forms"
        name="materialRequestForms"
        onClick={() => handleClick("materialRequestForms")}
        title={t("menu.materialRequestForms.title")}
        url="/vbuyer/material_request_forms"
      >
        <ListItemIcon sx={{ minWidth: "2rem" }}>
          <Icon icon={mdiListBoxOutline} />
        </ListItemIcon>
        {!!leftMenuOpen && (
          <ListItemText
            primary={t("menu.materialRequestForms.title")}
            slotProps={{
              primary: {
                sx: {
                  fontSize: 14,
                },
              },
            }}
            sx={{ whiteSpace: "normal" }}
          />
        )}
      </HybridRouteListItemButtonLink>
    );
  },
);
